// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-info__title-row{display:flex;align-items:center;gap:16px}@media(max-width: 576px){.order-info__title-row{border-bottom:1px solid #f2f1f4;padding:0 24px 16px;margin:0 -24px}}.order-info__arrow_left{transform:rotate(90deg)}.order-info__arrow_right{transform:rotate(-90deg)}", ""]);
// Exports
module.exports = exports;
